import { FunctionComponent, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { MemoryRouter } from 'react-router-dom';
import qs from 'qs';
import 'typeface-lobster';

import { Router } from '../Router';

import { Message } from '../../components/Message';
import { NavBar } from '../../components/NavBar';
import { Button } from '../../components/Button';

export const App: FunctionComponent = () => {
  const [open, setOpen] = useState<boolean | null>(null);

  useEffect(() => {
    const { reoptin } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    console.log(
      window.location.search,
      qs.parse(window.location.search, { ignoreQueryPrefix: true })
    );

    setOpen(reoptin === '1');
  }, []);

  return (
    <MemoryRouter>
      <NavBar />

      <Router />

      <Message />

      <Modal show={!!open}>
        <Modal.Header>Grazie!</Modal.Header>

        <Modal.Body>
          La tua preferenza è stata registrata con successo!
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setOpen(false)}>Chiudi</Button>
        </Modal.Footer>
      </Modal>
    </MemoryRouter>
  );
};
